import React from 'react'
import { Box,  Col, Flex, Row } from '../../../ppui';
import { AllowanceBox } from '../../style';
import { getDateProperFormatForInput, getDateProperFormatForInputFn } from '../../../utils/common';


const HolidayList = ({resource,handleEditModalOpen}) => {
     
if(!resource){
    throw new Promise(()=>{})
   }
       const bankRes = resource.read();

  return (
   
      <Flex gap={20} direction={"column"} >
    {
    
    !bankRes?.data?.data?.holidays?.length ? <p>No data</p> :
    bankRes?.data?.data?.holidays?.map(it=>(
      <AllowanceBox key={it?.holidayName}>
        <Row alignItems="center">
         
          <Col xs={12}>
            <Flex
              alignItems="center"
              gap={{ md: 20, lg: 40, xxl: 60 }}
            >
              <Box>
                <Box  className="label">Name</Box>
                <Box onClick={()=>handleEditModalOpen({...it,holidayDate: getDateProperFormatForInput(it?.holidayDate)})} className="value">{it?.holidayName}</Box>
              </Box>
              <Box>
                <Box className="label">Date</Box>
                <Box className="value">{

getDateProperFormatForInputFn(it?.holidayDate)||"-"}</Box>
              </Box>

              <Box>
                <Box className="label">Day</Box>
                <Box className="value">Sunday</Box>
              </Box>

           
            </Flex>
          </Col>
        </Row>
      </AllowanceBox>
    ))  }
    </Flex>

  )
}

export default HolidayList